import { Injectable, OnInit } from '@angular/core'
import * as moment from 'moment'
import { allMonths } from '../../../api/models/months.enum'
import { IDateable } from '../../ui/components/date-selector/idateable.interface'
import { notUndefined } from '../utils/conditional-assert'
import { PpwLocalStorageService } from './ppwlocalstorage.service'

@Injectable()
export class TimekeeperService implements OnInit {
    static generateMonths(): Array<string> {
        return moment.localeData().months()
    }

    static generateYears(): Array<number> {
        const yearList = new Array<number>()
        const today = moment()
        const year = today.get('year')
        const month = today.get('month')

        if (month >= 11) {
            yearList.push(year + 1)
        }
        for (let i = year; i >= 2016; i--) {
            yearList.push(i)
        }

        return yearList
    }
    set timeCardTimeFrame(newValue: IDateable) {
        this.ppwLocalStorageService.storeData(this.ppwLocalStorageService.STORAGE_KEY_TIMECARD_TIMEFRAME, newValue)
    }

    set timesheetTimeFrame(newValue: IDateable) {
        this.ppwLocalStorageService.storeData(this.ppwLocalStorageService.STORAGE_KEY_TIMESHEET_TIMEFRAME, newValue)
    }

    constructor(private readonly ppwLocalStorageService: PpwLocalStorageService) {}

    ngOnInit(): void {
        this.initializeTimeCardTimeFrame()
        this.initializeTimesheetTimeFrame()
    }

    getTimeCardTimeFrame(): IDateable {
        if (!this.ppwLocalStorageService.getStoredData(this.ppwLocalStorageService.STORAGE_KEY_TIMECARD_TIMEFRAME)) {
            this.initializeTimeCardTimeFrame()
        }

        return notUndefined(
            this.ppwLocalStorageService.getStoredData(this.ppwLocalStorageService.STORAGE_KEY_TIMECARD_TIMEFRAME)
        )
    }

    getTimesheetTimeFrame(): IDateable {
        if (!this.ppwLocalStorageService.getStoredData(this.ppwLocalStorageService.STORAGE_KEY_TIMESHEET_TIMEFRAME)) {
            this.initializeTimesheetTimeFrame()
        }

        const result = notUndefined(
            this.ppwLocalStorageService.getStoredData(this.ppwLocalStorageService.STORAGE_KEY_TIMESHEET_TIMEFRAME)
        )
        // This code may be obsolete in the future, we want to avoid saving null in the localstorage
        // This was used in timesheets v1, but not in timesheets v2.
        // TODO: Remove this when all old users have used the v2 timesheets.
        if (result.month === null) {
            result.month = undefined
        }

        return result
    }

    private initializeTimeCardTimeFrame(): void {
        const today = moment()
        const day = today.get('date')
        let timeCardYear: number
        let timeCardMonth: number

        // For first three days of the month we show the previous month
        if (day > 0 && day < 4) {
            today.subtract(1, 'months')
        }

        timeCardMonth = today.get('month')
        timeCardYear = today.get('year')
        this.timeCardTimeFrame = {
            month: allMonths[timeCardMonth],
            year: timeCardYear,
            startDate: moment().startOf('month'),
            endDate: moment().endOf('month')
        }
    }

    private initializeTimesheetTimeFrame(): void {
        const today = moment()
        const year = today.get('year')

        this.timesheetTimeFrame = {
            month: undefined,
            year,
            startDate: today.startOf('year'),
            endDate: today.endOf('year')
        }
    }
}
